import React from 'react';

const USAFlag = ({ className = "h-4 w-4", ...props }) => {
  return (
    <div className={`inline-flex items-center justify-center ${className}`} {...props}>
      <span className="text-base">🇺🇸</span>
    </div>
  );
};

export default USAFlag;